// extracted by mini-css-extract-plugin
export default {"ConfirmationDialog":"ConfirmationDialog_ConfirmationDialog__BoEH9"};